import * as React from "react";
import Loading from "../../components/loading";
import {gql} from "@apollo/client";
import {query} from "../../lib/apollo";
import {
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    FormControl, IconButton,
    InputLabel,
    MenuItem,
    Paper, Popover,
    Select,
    Table, TableBody,
    TableCell,
    TableContainer,
    TableHead, TableRow, TextareaAutosize
} from "@mui/material";
import TableHeaderRow from "../../components/TableHeaderRow";
import StripedTableRow from "../../components/StripedTableRow";
import IndeterminateCheckBoxOutlinedIcon from "@mui/icons-material/IndeterminateCheckBoxOutlined";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import LoadingDialog from "../../components/loadingDialog";
import {downloadPublishers} from "../publishers/publishersService";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import downloadCsv from "../../lib/downloadCsv";
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Box from "@mui/material/Box";

export default function CakeWeeklyPage() {
    const [loading, setLoading] = React.useState(true);
    const [weeks, setWeeks] = React.useState<any[]>([]);
    const [weekId, setWeekId] = React.useState<string>("0");
    const [publishers, setPublishers] = React.useState<any[]>([]);
    const [expanded, setExpanded] = React.useState<any>({});
    const [noteDialogOpen, setNoteDialogOpen] = React.useState<any>({weekId: 0, affiliateId: 0, campaignId: 0, note: ''} as any);
    const [anchorEls, setAnchorEls] = React.useState<any>({});

    React.useEffect(() => {
        document.title = "Cake Weekly Payments | DN";
        getWeeks().then(() => {});
    }, []);

    async function getWeeks() {
        const q = gql`
            query {
                cakeWeeks {
                    id
                    startTime
                    endTime
                }
            }
        `;
        const response = await query(q, null);

        if (response && response.cakeWeeks) {
            setWeeks(response.cakeWeeks);
            setWeek(response.cakeWeeks[0].id.toString());
        }
    }

    async function runBills() {
        setLoading(true);
        const q = gql`
            mutation {
                cakeMonthlyRunBills
            }
        `;
        await query(q, null);
        await setWeek(weekId);
    }

    async function setWeek(weekId: string) {
        setWeekId(weekId);
        setLoading(true);

        const q = gql`
            query($weekId: Int!) {
                cakeWeekPublishers(weekId: $weekId) {
                    total 
                    publishers {
                        id
                        weekId
                        name
                        total
                        note
                        campaigns {
                            clicks
                            conversions
                            format
                            id
                            campaignId
                            name
                            price
                            revenue
                            note
                        }
                        bills {
                            id
                            amount
                            startTime
                            endTime
                        }
                    }
                }
            }
        `;
        const variables = {
            weekId: parseInt(weekId)
        };
        const response = await query(q, variables);

        if (response && response.cakeWeekPublishers) {
            setPublishers(response.cakeWeekPublishers);
            // expand all by default
            response.cakeWeekPublishers.forEach((group: any) => {
                group.publishers.forEach((publisher: any) => {
                    setExpanded((prev: any) => ({...prev, [publisher.id]: true}));
                })
            });
        }
        setLoading(false);

    }

    function updateLiveNote(weekId: number, affiliateId: number, campaignId: number, note: string) {
        // find note
        setPublishers((prevPublishers) => {
            return prevPublishers.map((publisher) => {
                if (publisher.id === affiliateId) {
                    if (campaignId === 0) {
                        // affiliate note
                        return {...publisher, note: note};
                    } else {
                        // campaign note
                        const updatedCampaigns = publisher.campaigns.map((campaign: any) => {
                            if (campaign.campaignId === campaignId) {
                                return {...campaign, note: note};
                            }
                            return campaign;
                        });
                        return {...publisher, campaigns: updatedCampaigns};
                    }
                }
                return publisher;
            });
        });
    }

    async function download() {
        const content: any[] = [];

        const week = weeks.find((w) => w.id.toString() === weekId);
        content.push([`Weekly ${new Date(week.startTime).toLocaleDateString()} - ${new Date(week.endTime).toLocaleDateString()}`]);
        publishers.forEach((group: any) => {
            group.publishers.forEach((publisher: any) => {
                let isNew = '';
                content.push([]);
                content.push([`${publisher.name} (${publisher.id.toString()})` + isNew, ``, ``, ``, ``, ``, publisher.note ? `${publisher.note}` : '']);
                content.push([`Campaign`, `Format`, `Price`, `Clicks`, `Conversions`, `Revenue`, `Note`]);
                publisher.campaigns.forEach((campaign: any) => {
                    content.push([`${campaign.name} (${campaign.id}-${campaign.campaignId})`, campaign.format, `$${campaign.price.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`, campaign.clicks.toLocaleString(), campaign.conversions.toLocaleString(), `$${campaign.revenue.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}`, campaign.note ? `${campaign.note}` : '']);
                });
            })
            content.push([`Totals`, ``, ``, ``, ``, `$${group.total.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}`, ``]);
            content.push([`-`, `-`, `-`, `-`, `-`, `-`, `-`]);
        });


        await downloadCsv('weekly.csv', content);
    }

    return (
        <>
            <h2>Cake Weekly Payments</h2>

            {loading ? <Loading/> :
                <>
                    <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                        <InputLabel id="items-label">Weeks</InputLabel>
                        <Select
                            labelId="items-label"
                            value={weekId}
                            label="Items"
                            onChange={(e) => setWeek(e.target.value)}
                            size={'small'}
                        >
                            {weeks.map((w) => (
                                <MenuItem key={w.id} value={w.id}>
                                    {new Date(w.startTime).toLocaleDateString()} - {new Date(w.endTime).toLocaleDateString()}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Button aria-label="download" onClick={() => {download()}} variant={'contained'} color={'success'} sx={{marginTop: '10px'}}>
                        <FileDownloadIcon />&nbsp;Export
                    </Button>

                    <Button aria-label="download" onClick={() => {runBills()}} variant={'contained'} color={'warning'} sx={{marginTop: '10px', marginLeft: '10px'}}>
                        <AccountBalanceIcon />&nbsp;Import Bills
                    </Button>

                    <TableContainer component={Paper} sx={{maxWidth: 'calc(100vw - 10px)'}}>
                        <Table size="small">
                            <TableHead>
                                <TableHeaderRow>
                                    <TableCell>
                                        &nbsp;
                                    </TableCell>
                                    <TableCell>
                                        Publisher
                                    </TableCell>
                                    <TableCell align="right">
                                        Total
                                    </TableCell>
                                </TableHeaderRow>
                            </TableHead>
                            <TableBody>
                                {publishers.map((group: any, index: number) => (
                                    <React.Fragment key={index}>
                                        {group.publishers.map((row: any, index: number) => (
                                            <React.Fragment key={row.id}>
                                                <TableRow sx={{backgroundColor: row.isNew ? 'pink' : 'cyan'}}>
                                                    <TableCell sx={{width: '30px'}}>
                                                        <IconButton
                                                            onClick={(event) => {
                                                                setExpanded({...expanded, [row.id]: !expanded[row.id]})
                                                            }}
                                                        >
                                                            {!!expanded[row.id] && <IndeterminateCheckBoxOutlinedIcon sx={{fontSize: '20px'}} />}
                                                            {!expanded[row.id] && <AddBoxOutlinedIcon sx={{fontSize: '20px'}} />}
                                                        </IconButton>
                                                    </TableCell>
                                                    <TableCell>
                                                        {row.name} ({row.id}) {row.note && <em style={{backgroundColor: 'yellow'}}> - {row.note}</em>} <EditNoteIcon sx={{verticalAlign: 'middle', fontSize: '22px', color: 'blue', cursor: 'pointer'}} onClick={()=> setNoteDialogOpen({weekId: row.weekId, affiliateId: row.id, campaignId: 0, note: row.note})}/>
                                                    </TableCell>
                                                    <TableCell align="right" sx={{fontWeight: 'bold'}}>
                                                        {row.bills.length > 0 && <>
                                                            <AccountBalanceIcon sx={{verticalAlign: 'middle', fontSize: '22px', cursor: 'pointer', marginRight: '10px'}} onClick={(e) => setAnchorEls({...anchorEls, ['bill' + row.id]: e.currentTarget})}/>
                                                            <Popover
                                                                id={'bill' + row.id}
                                                                open={!!anchorEls['bill' + row.id]}
                                                                anchorEl={anchorEls['bill' + row.id]}
                                                                onClose={() => setAnchorEls({...anchorEls, ['bill' + row.id]: null})}
                                                            >
                                                                <Table size="small">
                                                                    <TableHead>
                                                                        <TableHeaderRow>
                                                                            <TableCell>
                                                                                Id
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                Date Range
                                                                            </TableCell>
                                                                            <TableCell align={'right'}>
                                                                                Amount
                                                                            </TableCell>
                                                                        </TableHeaderRow>
                                                                        {row.bills.map((bill: any) => (
                                                                            <TableRow key={bill.id}>
                                                                                <TableCell>
                                                                                    {bill.id}
                                                                                </TableCell>
                                                                                <TableCell>
                                                                                    {new Date(bill.startTime).toLocaleDateString()} - {new Date(bill.endTime).toLocaleDateString()}
                                                                                </TableCell>
                                                                                <TableCell align={'right'}>
                                                                                    ${bill.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableHead>
                                                                </Table>
                                                            </Popover>
                                                        </> }
                                                        ${row.total.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                    </TableCell>
                                                </TableRow>
                                                {!!expanded[row.id] && <TableRow key={`${row.id}-exp`}>
                                                    <TableCell colSpan={3}>
                                                        <Table size="small">
                                                            <TableHead>
                                                                <TableHeaderRow>
                                                                    <TableCell>
                                                                        Campaign
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        Format
                                                                    </TableCell>
                                                                    <TableCell align={'right'}>
                                                                        Price
                                                                    </TableCell>
                                                                    <TableCell align={'right'}>
                                                                        Clicks
                                                                    </TableCell>
                                                                    <TableCell align={'right'}>
                                                                        Conversions
                                                                    </TableCell>
                                                                    <TableCell align={'right'}>
                                                                        Revenue
                                                                    </TableCell>
                                                                </TableHeaderRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {row.campaigns.map((campaign: any) => (
                                                                    <StripedTableRow key={row.id + '-' +campaign.id + '-' + campaign.campaignId}>
                                                                        <TableCell>
                                                                            {campaign.name} ({campaign.id}-{campaign.campaignId}) {campaign.note && <em style={{backgroundColor: 'yellow'}}> - {campaign.note}</em>} <EditNoteIcon sx={{verticalAlign: 'middle', fontSize: '22px', color: 'blue', cursor: 'pointer'}} onClick={()=> setNoteDialogOpen({weekId: row.weekId, affiliateId: row.id, campaignId: campaign.campaignId, note: campaign.note})}/>
                                                                        </TableCell>
                                                                        <TableCell>
                                                                            {campaign.format}
                                                                        </TableCell>
                                                                        <TableCell align={'right'}>
                                                                            ${campaign.price.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        </TableCell>
                                                                        <TableCell align={'right'}>
                                                                            {campaign.clicks.toLocaleString()}
                                                                        </TableCell>
                                                                        <TableCell align={'right'}>
                                                                            {campaign.conversions.toLocaleString()}
                                                                        </TableCell>
                                                                        <TableCell align={'right'}>
                                                                            ${campaign.revenue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                                                        </TableCell>
                                                                    </StripedTableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </TableCell>
                                                </TableRow>
                                                }
                                            </React.Fragment>
                                        ))}
                                        <TableRow sx={{backgroundColor: 'orange'}}>
                                            <TableCell>
                                                &nbsp;
                                            </TableCell>
                                            <TableCell sx={{fontWeight: 'bold'}}>
                                                Totals
                                            </TableCell>
                                            <TableCell align="right" sx={{fontWeight: 'bold'}}>
                                                ${group.total.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <EditNote open={noteDialogOpen} setOpen={setNoteDialogOpen} updateLiveNote={updateLiveNote} />
                </>
            }
        </>
    );
}

function EditNote(params: {open: any, setOpen: React.Dispatch<React.SetStateAction<any>>, updateLiveNote: (weekId: number, affiliateId: number, campaignId: number, note: string) => void}) {
    const [note, setNote] = React.useState<string>('');
    const [loading, setLoading] = React.useState<boolean>(false);

    React.useEffect(() => {
        setNote(params.open.note || '');
    }, [params.open]);

    async function saveNote() {
        setLoading(true);
        const q = gql`
            mutation($input: CakeWeeksNote!) {
                cakeWeeksNotesUpdate(input: $input)
            }
        `;
        const variables = {
            input: {
                weekId: params.open.weekId,
                affiliateId: params.open.affiliateId,
                campaignId: params.open.campaignId,
                note: note
            }
        };
        const res = await query(q, variables);
        setLoading(false);

        if (res && res.cakeWeeksNotesUpdate) {
            params.setOpen({weekId: 0, affiliateId: 0, offerId: 0, note: ''})
            params.updateLiveNote(params.open.weekId, params.open.affiliateId, params.open.campaignId, note);
        }
    }

    return (
        <Dialog
            open={!!params.open.weekId}
            onClose={() => params.setOpen({weekId: 0, affiliateId: 0, offerId: 0, note: ''})}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
        >
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <FormControl fullWidth sx={{marginTop: 2}}>
                        <TextField
                            label="Note"
                            multiline
                            rows={4}
                            placeholder={"Enter note here"}
                            value={note}
                            onChange={(e: any) => setNote(e.target.value)}
                        />
                    </FormControl>
                </DialogContentText>
            </DialogContent>
            {loading ? <LoadingDialog/> :
                <DialogActions>
                    <Button sx={{color: 'green'}} onClick={() => saveNote() }>Save</Button>
                    <Button sx={{color: 'red'}} onClick={() => params.setOpen({weekId: 0, affiliateId: 0, offerId: 0, note: ''})}>Close</Button>
                </DialogActions>
            }
        </Dialog>
    );
}
